/* eslint-disable react/jsx-props-no-spreading */
import { NoAccessPage } from '@acin/terminal-onboarding';
import { Loading, PrivateRoute as UiCorePrivateRoute } from '@acin/ui-core';
import { useAuth } from '@acin/user-accounts';
import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { allRegMappingUserRoles } from '../auth0/regMappingUserRoles';

export const PrivateRoute: React.FC<RouteProps> = (props) => {
  const { isAuthenticated, loading, hasRole } = useAuth();
  const { children, ...rest } = props;

  if (loading) {
    return <Loading position="absolute" withOverlay />;
  }

  const renderContent = () => {
    if (!hasRole(allRegMappingUserRoles)) {
      return <Route {...rest} render={() => <NoAccessPage userName="" hasAccount={false} />} />;
    }
    return children;
  };

  return (
    // UiCorePrivateRoute will push user not authenticated to "/login"
    <UiCorePrivateRoute isAuthenticated={isAuthenticated} redirectPath="/login">
      {renderContent()}
    </UiCorePrivateRoute>
  );
};
